export const getFullImageUrl = (path) => {
  if (!path) return "";

  // 1. Handle Google Drive links
  // Convert https://drive.google.com/file/d/ID/view?usp=sharing 
  // to https://drive.google.com/uc?export=view&id=ID
  const driveRegex = /drive\.google\.com\/file\/d\/([^/]+)/;
  const driveMatch = path.match(driveRegex);
  if (driveMatch && driveMatch[1]) {
    return `https://drive.google.com/uc?export=view&id=${driveMatch[1]}`;
  }

  // 2. Handle absolute URLs (http or https)
  if (path.startsWith("http")) {
    return path;
  }

  // 3. Handle relative backend paths
  const baseUrl = (process.env.REACT_APP_API_URL || "http://localhost:5000").replace(/\/+$/, "");
  const cleanPath = path.replace(/^\/+/, "");
  return `${baseUrl}/${cleanPath}`;
};
